module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_02_1280_1280_vi-b846359e08f8a408b78c565526326682.jpg";